import types from '../mutation-types';
import DashboardHomeAPI from '../../api/dashboardHome';

export const state = {
  data: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getHomeStats(_state) {
    return _state.data;
  },
  getMyStats(_state) {
    return _state.data.my_stats || {};
  },
  getCompanyStats(_state) {
    return _state.data.company_stats || {};
  },
  getLeaderboard(_state) {
    return _state.data.leaderboard || [];
  },
  getFunnel(_state) {
    return _state.data.funnel || [];
  },
  getMyRecentDeals(_state) {
    return _state.data.my_recent_deals || [];
  },
  getCompanyRecentDeals(_state) {
    return _state.data.company_recent_deals || [];
  },
  getMyTasks(_state) {
    return _state.data.my_tasks || [];
  },
};

export const actions = {
  fetchHomeStats: async function fetchHomeStats({ commit }) {
    commit(types.SET_DASHBOARD_HOME_UI_FLAG, { isFetching: true });
    try {
      const response = await DashboardHomeAPI.getHomeStats();
      commit(types.SET_DASHBOARD_HOME_STATS, response.data);
    } catch (error) {
      console.error('Dashboard home stats error:', error);
    } finally {
      commit(types.SET_DASHBOARD_HOME_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_DASHBOARD_HOME_STATS](_state, data) {
    _state.data = data;
  },
  [types.SET_DASHBOARD_HOME_UI_FLAG](_state, flag) {
    _state.uiFlags = { ..._state.uiFlags, ...flag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
